import { Container as Image } from '@components/common/Image/Image.styles';
import tw, { styled } from 'twin.macro';

// TODO: here change grid system

export const Container = styled.div`
  ${tw`col-start-1 col-span-12 md:col-start-1 md:col-span-full lg:col-start-2 lg:col-span-10 xl:col-start-2 xl:col-span-11 2xl:col-span-full 2xl:col-start-1`};
`;

export const Content = styled.div`
  ${tw`relative`}
`;

export const Thumbnail = styled.div`
  position: relative;
  ${tw`grid grid-cols-1`};

  ${Image} {
    padding-top: 0;
    padding-bottom: 1rem;
  }
`;
